import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

// Request body kept hand-authored: the generated SendEmailRequest types every field as
// nullable and `data` as Record<string, never>, which is awkward to construct against.
// The response type derives from the contract.
export interface SendEmailBody {
  to: string;
  from: { email: string; name?: string };
  subject?: string;
  html?: string;
  text?: string;
  template_id?: string;
  data?: Record<string, unknown>;
  client_message_id?: string;
  categories?: string[];
}

export type SendEmailResult = Schemas['SendEmailResult'];

export const email = {
  send: (body: SendEmailBody) =>
    request<SendEmailResult>('/v1/email/send', { method: 'POST', body }),
};
